export default function MySQL_COUNTAVG() {
  return (
    <div>
      <h2>MySQL_COUNTAVG</h2>    </div>
  );
}